module.exports = __webpack_public_path__ + "assets/fonts/5e02ee1a-8ec4-462c-9754-b73a3927077a.a73938ff.woff2";